var TemplateLibraryHeaderSaveView;

TemplateLibraryHeaderSaveView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-template-library-header-save',

	id: 'kitbuilder-template-library-header-save',

	className: 'kitbuilder-template-library-header-item',

	events: {
		'click': 'onClick'
	},

	onClick: function() {
		kitbuilder.templates.getLayout().showSaveTemplateView();
	}
} );

module.exports = TemplateLibraryHeaderSaveView;
